import type { TvStoreApi } from '../store';
import { devMembers, devMeta, devQueue, devSession, hostUser } from './placeholders';

/**
 * Seeds a signed-in host session with the Figma placeholder data so the post-auth screens
 * can be exercised in desktop Chrome (`?screen=home|search|profile|queue|player`).
 * Never used on a real TV: pairing (WP1.2) fills the same slices from the API/RTDB.
 */
export function seedDevSession(store: TvStoreApi): void {
  const s = store.getState();
  s.setAuth({
    status: 'signed_in',
    uid: hostUser.id,
    user: hostUser,
    features: devSession.features,
  });
  s.setSession(devSession);
  s.setMeta(devMeta);
  s.setMembers(devMembers);
  s.setQueue(devQueue);
  s.setRemotePlayer({ state: 'playing', currentItemId: '01J8Z5K3M4N5P6Q7R8S9T0S603' });
}
